import { defineMessages } from "react-intl"

export default defineMessages({
  headerStudioTesting: {
    id: "app.components.StudioTesting.headerStudioTesting",
  },
  studioTesting: {
    id: "app.components.StudioTesting.studioTesting",
  },
  studio: {
    id: "app.components.StudioTesting.studio",
  },
  "countries.Canada": {
    id: "app.components.StudioTesting.countries.Canada",
  },
  "countries.France": {
    id: "app.components.StudioTesting.countries.France",
  },
  "countries.UnitedStates": {
    id: "app.components.StudioTesting.countries.UnitedStates",
  },
  "countries.UnitedKingdom": {
    id: "app.components.StudioTesting.countries.UnitedKingdom",
  },
  "countries.Germany": {
    id: "app.components.StudioTesting.countries.Germany",
  },
  "countries.Sweden": {
    id: "app.components.StudioTesting.countries.Sweden",
  },
  "countries.Finland": {
    id: "app.components.StudioTesting.countries.Finland",
  },
  "countries.Singapore": {
    id: "app.components.StudioTesting.countries.Singapore",
  },
  "countries.Romania": {
    id: "app.components.StudioTesting.countries.Romania",
  },
  "countries.China": {
    id: "app.components.StudioTesting.countries.China",
  },
  "countries.Japan": {
    id: "app.components.StudioTesting.countries.Japan",
  },
})
